const EndedArrowRight = () => (
  <>
    <path
      fill="currentColor"
      d="M20 18.5q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144A.48.48 0 0 1 19 18.5v-13q0-.213.144-.356A.49.49 0 0 1 19.501 5q.212 0 .356.144A.49.49 0 0 1 20 5.5zm-4.021-6.498a.8.8 0 0 1-.053.296.8.8 0 0 1-.184.268l-3.388 3.388a.5.5 0 0 1-.344.15.47.47 0 0 1-.364-.15.5.5 0 0 1-.16-.354.5.5 0 0 1 .16-.354l2.746-2.746H4.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 4.5 11.5h9.892l-2.746-2.746a.5.5 0 0 1-.15-.344.47.47 0 0 1 .15-.364.5.5 0 0 1 .354-.16.5.5 0 0 1 .354.16l3.388 3.389a.8.8 0 0 1 .184.27.8.8 0 0 1 .053.297"
    />
  </>
)
export default EndedArrowRight
